import { render, staticRenderFns } from "./gifts-section.vue?vue&type=template&id=51e51d1a&"
import script from "./gifts-section.vue?vue&type=script&lang=js&"
export * from "./gifts-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GiftsProduct: require('/opt/build/repo/storefront/components/legacy/gifts/gifts-product.vue').default})
